import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import axios from "axios";
import MarcadorBunion from "../assets/images/MarcadorBUnion.png";
import MarcadorEfecty from "../assets/images/MarcadorEfecty.png";
import MarcadorMultipagas from "../assets/images/MarcadorMultipagas.png";
import MarcadorCoopenesa from "../assets/images/MarcadorCoopenesa.png";
import MarcadorCFA from "../assets/images/MarcadorCFA.png";
import MarcadorBAgrario from "../assets/images/MarcadorBancoAgrario.png";
import "../css/HomeMap.css";

export const HomeMap = (props) => {
  const [UserLocation, setUserLocation] = useState([]);
  const [InfoBurbuja, setInfoBurbuja] = useState([]);

  const mapStyle = {
    height: "886px",
    width: "100%",
  };

  const defaultCenter = {
    lat: 4.709179381180749,
    lng: -74.07704923544372,
  };

  const mapOptions = {
    minZoom: 14,
    maxZoom: 18,
    clickeableIcons: false,
    disableDoubleClickZoom: false,
    zoomControl: true,
    disableDefaultUI: true,
  };

  useEffect(() => {
    setUserLocation(defaultCenter);
  }, []);

  const LogoMarcador = (NombreConvenio) => {
    switch (NombreConvenio) {
      case "Efecty":
        return MarcadorEfecty;

      case "Multipagas":
        return MarcadorMultipagas;

      case "CFA":
        return MarcadorCFA;

      case "coopenesa":
        return MarcadorCoopenesa;

      case "Banco Agrario":
        return MarcadorBAgrario;

      case "Banco Union":
        return MarcadorBunion;
      default:
        break;
    }
  };

  const [infoOpen, setInfoOpen] = useState(null);

  const handleToggle = (id, det) => {
    obtenerDetalles(det).then((result) => {
      if (result.data[0] === undefined) {
        setInfoBurbuja(result.data);
        setInfoOpen(id);
      } else {
        setInfoBurbuja(result.data[0]);
        setInfoOpen(id);
      }
    });
  };

  const obtenerDetalles = (det) => {
    const res = axios.get(
      process.env.REACT_APP_ENDPOINT + "/getdetail?place=" + det
    );
    return res;
  };

  const DireccionCompleta = (direccion) => {
    const arr = direccion.split(",");
    return arr.slice(0, -3);
  };
  const ObtenerHoras = (Sucursal, NumSwitch) => {
    switch (NumSwitch) {
      case 1:
        var HorasLunes = Sucursal.split("Monday: ");
        return HorasLunes[1];

      case 2:
        var HorasMartes = Sucursal.split("Tuesday: ");
        return HorasMartes[1];

      case 3:
        var HorasMiercoles = Sucursal.split("Wednesday: ");
        return HorasMiercoles;
      case 4:
        var HorasJueves = Sucursal.split("Thursday: ");
        return HorasJueves;
      case 5:
        var HorasViernes = Sucursal.split("Friday: ");
        return HorasViernes;
      case 6:
        var HorasSabado = Sucursal.split("Saturday: ");
        return HorasSabado;
      case 7:
        var HorasDom = Sucursal.split("Sunday: ");
        return HorasDom[1] === "0 - 0" || HorasDom[1] === "Closed"
          ? "CERRADO"
          : HorasDom[1];
      default:
        return "a";
    }
  };
  return (
    <div className="mapaClase">
      <LoadScript googleMapsApiKey={process.env.REACT_APP_API_KEY}>
        <GoogleMap
          mapContainerStyle={mapStyle}
          zoom={14}
          max
          center={
            props.centerCity === undefined ? UserLocation : props.centerCity
          }
          options={mapOptions}
        >
          {props.Marcadores.map((mark, index) => (
            <div>
              <Marker
                key={mark.place_id}
                onClick={() => {
                  handleToggle(index, mark.place_id);

                  props.handleElegirSucursal(mark);
                }}
                icon={{
                  url: LogoMarcador(mark.Convenio),
                  scaledSize:
                    mark.Convenio === undefined
                      ? new window.google.maps.Size(90, 100)
                      : null,
                }}
                position={mark.geometry.location}
              >
                {infoOpen === index && (
                  <InfoWindow position={mark.geometry.location}>
                    <div
                      style={{
                        width: "300px",
                        height: "300px",
                        fontFamily: "lato",
                      }}
                    >
                      <div style={{ margin: "10px" }}>
                        <br />
                        <h5>
                          {DireccionCompleta(InfoBurbuja.formatted_address)}{" "}
                        </h5>

                        <span>
                          Banco Unión{" "}
                          {mark.Convenio ? `convenio con ${mark.Convenio}` : ""}{" "}
                        </span>
                        <br />
                        <br />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#00a3e1",
                            fontFamily: "RubikBold",
                          }}
                        >
                          Horarios de atención{" "}
                        </span>
                        <br />
                        <br />
                        <div style={{ lineHeight: "1.8" }}>
                          <span>
                            Lunes:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[0],
                              1
                            )}{" "}
                          </span>{" "}
                          <br />
                          <span>
                            Martes:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[1],
                              2
                            )}{" "}
                          </span>
                          <br />
                          <span>
                            Miercoles:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[2],
                              3
                            )}{" "}
                          </span>
                          <br />
                          <span>
                            Jueves:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[3],
                              4
                            )}{" "}
                          </span>
                          <br />
                          <span>
                            Viernes:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[4],
                              5
                            )}{" "}
                          </span>
                          <br />
                          <span>
                            Sábado:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[5],
                              6
                            )}{" "}
                          </span>
                          <br />
                          <span>
                            Domingo:{" "}
                            {ObtenerHoras(
                              InfoBurbuja.opening_hours.weekday_text[6],
                              7
                            )}{" "}
                          </span>
                          <br />
                        </div>
                      </div>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            </div>
          ))}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};
